import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

import MaleAppBackground from './img/DownloadAppMaleBg.webp';
import FemaleAppBackground from './img/DownloadAppFemaleBg.webp';

import { color } from 'theme/selectors';

export type Variant = 'male' | 'female';

const getBackgroundImage = (variant: Variant) => {
    return variant === 'female' ? FemaleAppBackground : MaleAppBackground;
};

export const Container = styled(Box)<{ $variant: Variant }>`
    padding: 0 16px 32px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex: 1 0 0;
    height: calc(100vh - 56px);
    background:
        linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 181.4%),
        url(${(props) => getBackgroundImage(props.$variant)}) center / cover no-repeat;
`;

export const Email = styled.span`
    color: ${color('text-main')};
    font-weight: bold;
`;
